export const mapToObj = (x) => {
  return Array.from(x).reduce((obj, [key, value]) => (
    Object.assign(obj, { [key]: value })
  ), {});
};